import { render, staticRenderFns } from "./comp_dpc-WallBrands.vue?vue&type=template&id=15a47ae6&scoped=true&"
import script from "./comp_dpc-WallBrands.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-WallBrands.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-WallBrands.vue?vue&type=style&index=0&id=15a47ae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a47ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCol,VContainer,VRow})
